import React from "react";
import Button from "@mui/material/Button";
import ArrowRight from "@mui/icons-material/KeyboardArrowRight";
import "../../../styles/button.scss"

const NextButton = ({label='', onClick = () => {}, style= {}}) => {

    return <Button variant="contained" color="primary" onClick={onClick} sx={{marginTop:2, width: { xs: '100%', sm: 'auto' } }}>
        {label}
        <ArrowRight />
    </Button>
}

export default NextButton
